<template>
    <ul :dusk="props.dusk" class="forms__field--color__list">
        <li
            v-for="(color, colorindex) in colors"
            :key="colorindex"
            class="forms__field--color__single"
            :class="[
                color.class ? `bg-${color.class}-600` : ``,
                color.class ? `hover:bg-${color.class}-800` : '',
                { 'forms__field--color__single--selected': modelValue === color.id },
            ]"
            :style="color.hex ? { backgroundColor: color.hex } : {}"
            :dusk="`form-color-${colorindex}`"
            @click="modelValue = color.id"
        ></li>
        <li class="sr-only">
            <input :id="props.id" type="text" class="sr-only" :tabindex="props.tabindex" @focusin="selectFirstColor" />
        </li>
    </ul>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel({
    type: String,
});

const props = withDefaults(defineProps<FieldComponent>(), {
    dusk: null,
    colors: () => [],
});

const getDefaultColors = () => [
    { id: 'red', name: 'Red', class: 'red' },
    { id: 'yellow', name: 'Yellow', class: 'yellow' },
    { id: 'green', name: 'Green', class: 'green' },
    { id: 'blue', name: 'Blue', class: 'blue' },
    { id: 'indigo', name: 'Indigo', class: 'indigo' },
    { id: 'purple', name: 'Purple', class: 'purple' },
    { id: 'pink', name: 'Pink', class: 'pink' },
    { id: 'gray', name: 'Gray', class: 'gray' },
    { id: 'neutral', name: 'Neutral', class: 'neutral' },
];

const getPropsColors = () => {
    return props.colors.map((color: any) =>
        typeof color === 'string'
            ? { id: color, name: color, class: color }
            : { id: color.id, name: color.name, hex: color.hex },
    );
};

const getColors = () => {
    return props.colors && props.colors.length > 0 ? getPropsColors() : getDefaultColors();
};

const colors = ref(getColors());

const selectFirstColor = () => {
    if (colors.value.length > 0) {
        modelValue.value = colors.value[0].id;
    }
};

watch(
    () => props.colors,
    () => {
        colors.value = getColors();
    },
    { immediate: true },
);
</script>
